export enum Pages {
  LOGIN = "Login",
  DASHBOARD = "Dashboard",
  CLIENT = "Client",
  NEW_BUSINESS = "New Business",
  EXISTING_BUSINESS = "Existing Policies (Carrier Feeds)",
  ANNUITY_DETAIL = "Annuity Detail",
  LIFE_DETAIL = "Life Detail",
  EXISTING_POLICIES= "Existing Policies (No Feeds)",
}
